var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.date)?_c('div',{staticClass:"project-end-table-cell"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }